import { FC, MouseEvent, useState } from 'react';
import { Button, Menu, MenuItem, Theme, useMediaQuery } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { FormattedMessage } from 'react-intl';
import { Add } from '@mui/icons-material';

type Props = {
	readonly onPhaseCreate: () => void;
	readonly onActivityCreate: () => void;
	readonly disableActivityCreation: boolean;
};

const CreateButton: FC<Props> = ({ onPhaseCreate, onActivityCreate, disableActivityCreation }) => {
	const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);
	const matchUpSM = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

	const isOpen = anchorElement != null;

	const handleOpen = (event: MouseEvent<HTMLElement>) => {
		setAnchorElement(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorElement(null);
	};

	return (
		<>
			<Button
				variant={'contained'}
				onClick={handleOpen}
				sx={!matchUpSM ? { '.MuiButton-startIcon': { margin: 0, svg: { height: '18px' } }, p: 1, minWidth: 0 } : {}}
				startIcon={<Add sx={{ width: 18 }} />}
				endIcon={matchUpSM && <KeyboardArrowDownIcon />}
			>
				{matchUpSM && <FormattedMessage id={'journey.detail.create'} />}
			</Button>
			<Menu open={isOpen} anchorEl={anchorElement} onClose={handleClose}>
				<MenuItem
					onClick={() => {
						handleClose();
						onPhaseCreate();
					}}
				>
					<FormattedMessage id={'journey.detail.create-phase'} />
				</MenuItem>
				<MenuItem
					disabled={disableActivityCreation}
					onClick={() => {
						handleClose();
						onActivityCreate();
					}}
				>
					<FormattedMessage id={'journey.detail.create-activity'} />
				</MenuItem>
			</Menu>
		</>
	);
};

export { CreateButton };
